const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    show_tonnage: {
      type: 'boolean',
      title: 'tonnage',
    },
    show_hours: {
      type: 'boolean',
      title: 'total_houre',
    },
    show_activity_type: {
      type: 'boolean',
      default: true,
      title: 'task_type',
    },
    show_operation_type: {
      type: 'boolean',
      default: true,
      title: 'operation_type',
    },
    show_shift_type: {
      type: 'boolean',
      title: 'shift_type',
    },
    show_description: {
      type: 'boolean',
      title: 'description',
    },
    show_cost: {
      type: 'boolean',
      title: 'cost',
    },
    show_loader_count: {
      type: 'boolean',
      default: true,
      title: 'تعداد لودر',
    },

    show_loader_tonnage: {
      type: 'boolean',
      default: true,
      title: 'تبدیل شده تناژی لودر',
    },
    show_loader_hours: {
      type: 'boolean',
      title: 'ساعت لودر',
    },
  },
});

export default schema;
